import { getStoreValue, stores } from "../../utils/store";
import { testTasks } from "../../utils/testData";
import { TaskProps } from "../task";

var fakeIdCouter = Math.round(Math.random() * 100000000);

export async function addTaskRequest(task: TaskProps): Promise<TaskProps> {
    setTimeout(() => localStorage.setItem('tasks', JSON.stringify(getStoreValue(stores.tasks))), 100);
    task.id = fakeIdCouter++;
    return task;
}

export async function editTaskRequest(task: TaskProps): Promise<TaskProps> {
    setTimeout(() => localStorage.setItem('tasks', JSON.stringify(getStoreValue(stores.tasks))), 100);
    return task;
}

export async function removeTaskRequest(id: TaskProps['id']): Promise<boolean> {
    setTimeout(() => localStorage.setItem('tasks', JSON.stringify(getStoreValue(stores.tasks))), 100);
    return true;
}

export async function getTasksRequest(): Promise<TaskProps[]> {
    const tasks = localStorage.getItem('tasks');
    if (tasks) return JSON.parse(tasks);
    return testTasks;
}

export async function doneTaskRequest(id: TaskProps['id']): Promise<boolean> {
    setTimeout(() => localStorage.setItem('tasks', JSON.stringify(getStoreValue(stores.tasks))), 100);
    return true;
}